/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { LiteralsService } from 'src/app/shared/services/literals-service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ParameterService } from 'src/app/shared/services/parameters.service';

@Component({
  selector: 'tgv-incorrect-configuration',
  standalone: false,
  templateUrl: './incorrect-configuration.component.html',
  styleUrls: ['./incorrect-configuration.component.css']
})
export class IncorrectConfigurationComponent implements OnInit {
  id: string;
  description: string;
  literals: LiteralsWords;
  linkDoc: string;

  constructor(
    private literalsService: LiteralsService,
    private loginService: LoginService,
    private router: Router,
    private parameterService: ParameterService
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.id = this.getIdDescription();
    this.setDescription(this.id);
  }

  goBack(): void {
    if (this.id === 'disabled-security' || this.id === '' || this.id === 'backend-updated-pgv') {
      this.parameterService.isError = false;
      this.loginService.logoutAuth();
    } else if (this.id === 'lib-version-customer-incompatible' || this.id === 'disabled-security-customer' ||
      this.id === 'backend-not-updated') {
      this.router.navigate(['customers']);
    }
  }

  getIdDescription(): string {
    return this.router.routerState.snapshot.root.queryParams['id'];
  }

  setDescription(id: string) {
    const description =
    {
      'disabled-security': this.literals.str0718,
      'lib-version-customer-incompatible': this.literals.str0719,
      'disabled-security-customer': this.literals.str0718,
      'backend-not-updated': this.literals.str0721,
      'backend-updated-pgv': this.literals.str0935
    };
    this.description = description[id] || '';

    if (id === 'backend-updated-pgv') {
      this.linkDoc = 'https://tdn.totvs.com/pages/viewpage.action?pageId=1025243471';
    }
  }
}
